type Props = {
  when?: boolean;
};

export default function Visible({
  when,
  children,
}: React.PropsWithChildren<Props>) {
  return when ? children : null;
}
